import React from 'react';
import InnerTargetField from '../InnerTargetField';

const TargetFieldDataForSourceVariable = ({ fieldName, readOnly = false }) => {
  return (
    <>
      <InnerTargetField fieldName={fieldName} readOnly={readOnly}/>
    </>
  );
};

export default TargetFieldDataForSourceVariable;
